import { render, staticRenderFns } from "./AdminLocations.vue?vue&type=template&id=4ca5cf5e&scoped=true"
import script from "./AdminLocations.vue?vue&type=script&lang=js"
export * from "./AdminLocations.vue?vue&type=script&lang=js"
import style0 from "./AdminLocations.vue?vue&type=style&index=0&id=4ca5cf5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5cf5e",
  null
  
)

export default component.exports